
export const groupNameBySlug = {
    superadministrador: 'Super Administrador',
    administrador: 'Administrador',
    assessor: 'Assessor',
    defensor: 'Defensor',
    leitura: 'Leitura',
    'lotacao:corregedoria_geral': 'Corregedoria-Geral',
    'lotacao:secretaria_da_corregedoria_geral': 'Secretaria da Corregedoria-Geral',
    'lotacao:primeira_subcorregedoria_geral': 'Primeira Subcorregedoria-Geral',
    'lotacao:segunda_subcorregedoria_geral': 'Segunda Subcorregedoria-Geral',
    'lotacao:escola_superior': 'Escola Superior',
    // ...
}

export const shortGroupNameBySlug = {
    'lotacao:primeira_subcorregedoria_geral': '1ª Sub',
    'lotacao:segunda_subcorregedoria_geral': '2ª Sub',
}

export const status = {
    RASCUNHO: 'rascunho',
    EDITADO: 'editado',
    NOTIFICADO: 'notificado',
    FALHA_NA_NOTIFICACAO: 'falha_na_notificacao',
    AGUARDANDO_CORRECAO: 'aguardando_correcao',
    AGUARDANDO_MANIFESTACAO: 'aguardando_manifestacao',
    MANIFESTACAO_RECEBIDA: 'manifestacao_recebida',
    HOMOLOGADO: 'homologado',
}

export const statusBySlug = {
    [status.RASCUNHO]: 'Rascunho',
    [status.EDITADO]: 'Em edição',
    [status.NOTIFICADO]: 'Notificado',
    [status.FALHA_NA_NOTIFICACAO]: 'Falha na notificação',
    [status.AGUARDANDO_CORRECAO]: 'Aguardando correção',
    [status.AGUARDANDO_MANIFESTACAO]: 'Aguardando manifestação',
    [status.MANIFESTACAO_RECEBIDA]: 'Manifestação recebida',
    [status.HOMOLOGADO]: 'Homologado',
    // ...
}
